import React from 'react';
import {
  BooleanInput,
  FormDataConsumer,
  TextInput,
} from 'react-admin';
import _ from 'lodash';

export default props => (
  <div>
    <BooleanInput
      label="Disable Inbound Bank Transfer in Funnel (To: My IPO / Deposit)"
      source="appConfig.bankTransfer.disabledInboundFunnel"
      style={{ width: '100%' }}
      {...props}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData &&
        formData.appConfig &&
        formData.appConfig.bankTransfer &&
        formData.appConfig.bankTransfer.disabledInboundFunnel &&
        <TextInput
          label="Inbound Transfer Funnel Alert Text"
          source="appConfig.bankTransfer.disabledInboundDisclaimerFunnel"
          multiline
          minRows={1}
          maxRows={4}
          style={{ width: '100%' }}
          {...rest}
          validate={value => (_.isEmpty(value) ? 'A disclaimer text needs to be provided' : null)}
        />
      }
    </FormDataConsumer>
    <BooleanInput
      label="Disable Outbound Bank Transfer in Funnel (From: My IPO / Withdrawal)"
      source="appConfig.bankTransfer.disabledOutboundFunnel"
      style={{ width: '100%' }}
      {...props}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData &&
        formData.appConfig &&
        formData.appConfig.bankTransfer &&
        formData.appConfig.bankTransfer.disabledOutboundFunnel &&
        <TextInput
          label="Outbound Transfer Funnel Alert Text"
          source="appConfig.bankTransfer.disabledOutboundDisclaimerFunnel"
          multiline
          minRows={1}
          maxRows={4}
          style={{ width: '100%' }}
          {...rest}
          validate={value => (_.isEmpty(value) ? 'A disclaimer text needs to be provided' : null)}
        />
      }
    </FormDataConsumer>
    <BooleanInput
      label="Disable Inbound Bank Transfer in Mobile (To: My IPO / Deposit)"
      source="appConfig.bankTransfer.disabledInboundMobile"
      style={{ width: '100%' }}
      {...props}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData &&
        formData.appConfig &&
        formData.appConfig.bankTransfer &&
        formData.appConfig.bankTransfer.disabledInboundMobile &&
        <TextInput
          label="Inbound Transfer Mobile Alert Text"
          source="appConfig.bankTransfer.disabledInboundDisclaimerMobile"
          multiline
          minRows={1}
          maxRows={4}
          style={{ width: '100%' }}
          {...rest}
          validate={value => (_.isEmpty(value) ? 'A disclaimer text needs to be provided' : null)}
        />
      }
    </FormDataConsumer>
    <BooleanInput
      label="Disable Outbound Bank Transfer in Mobile (From: My IPO / Withdrawal)"
      source="appConfig.bankTransfer.disabledOutboundMobile"
      style={{ width: '100%' }}
      {...props}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData &&
        formData.appConfig &&
        formData.appConfig.bankTransfer &&
        formData.appConfig.bankTransfer.disabledOutboundMobile &&
        <TextInput
          label="Outbound Transfer Mobile Alert Text"
          source="appConfig.bankTransfer.disabledOutboundDisclaimerMobile"
          multiline
          minRows={1}
          maxRows={4}
          style={{ width: '100%' }}
          {...rest}
          validate={value => (_.isEmpty(value) ? 'A disclaimer text needs to be provided' : null)}
        />
      }
    </FormDataConsumer>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Config/BankTransferConfig.jsx